const deliStatus = [
    { value: "none", name: "None" },
    { value: "refund", name: "Refunded" },
    { value: "error", name: "Error" },
    { value: "delivered", name: "Delivered" },
    { value: "case_item", name: "Case item not received" },
    { value: "case_des", name: "Case not as described" },
]
export default deliStatus